// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DebounceP = require("../../reason/common/DebounceP.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var SearchField = require("../../reason/chapter/components/SearchField.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ChapterMembersListItem = require("./ChapterMembersListItem.bs.js");
var HighlightSection__Jsx3 = require("../../uikit/reason/atoms/Sections/HighlightSection__Jsx3.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PaginationBoxRefetchable = require("../common/pagination/PaginationBoxRefetchable.bs.js");
var ChapterMembersListRelayQueryParams = require("./ChapterMembersListRelayQueryParams.bs.js");
var ChapterMembersListRelay_chapter_graphql = require("../../__generated__/ChapterMembersListRelay_chapter_graphql.bs.js");
var ChapterMembersListRelayPaginationQuery_graphql = require("../../__generated__/ChapterMembersListRelayPaginationQuery_graphql.bs.js");

var convertFragment = ChapterMembersListRelay_chapter_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterMembersListRelay_chapter_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterMembersListRelay_chapter_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ChapterMembersListRelay_chapter_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterMembersListRelay_chapter_graphql.node, convertFragment, fRef);
}

var makeRefetchVariables = ChapterMembersListRelayPaginationQuery_graphql.Types.makeRefetchVariables;

var convertRefetchVariables = ChapterMembersListRelayPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(ChapterMembersListRelay_chapter_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

var ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable
};

function ChapterMembersListRelay(props) {
  var match = ChapterMembersListRelayQueryParams.use();
  var setQueryParams = match[1];
  var queryParams = match[0];
  var match$1 = useRefetchable(props.chapter);
  var refetch = match$1[1];
  var chapter = match$1[0];
  var match$2 = React.useTransition();
  var startTransition = match$2[1];
  var match$3 = React.useState(function () {
        return Core__Option.getOr(queryParams.search, "");
      });
  var setSearchText = match$3[1];
  var searchText = match$3[0];
  var s = searchText.trim();
  var searchTextOpt = s === "" ? undefined : s;
  var search = React.useCallback(DebounceP.make(300, (async function (searchText) {
              return startTransition(function () {
                          refetch(makeRefetchVariables(Caml_option.some(undefined), Caml_option.some(undefined), 10, Caml_option.some(undefined), chapter.nodeId, Caml_option.some(searchText)), undefined, undefined);
                        });
            })), [
        refetch,
        startTransition
      ]);
  var match$4 = chapter.members;
  var tmp;
  if (match$4 !== undefined) {
    var match$5 = match$4.pageInfo;
    var startCursor = match$5.startCursor;
    var endCursor = match$5.endCursor;
    var members = Core__Array.keepSome(Core__Option.getOr(match$4.edges, [])).map(function (e) {
          return e.node;
        });
    var search$1 = Core__Option.getOr(Core__Option.map(searchTextOpt, (function (s) {
                return "&search=" + encodeURIComponent(s);
              })), "");
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            members.length !== 0 ? JsxRuntime.jsx("div", {
                    children: members.map(function (agent) {
                          return JsxRuntime.jsx(ChapterMembersListItem.make, {
                                      agent: agent.fragmentRefs
                                    }, agent.id);
                        }),
                    className: "flex flex-col space-y-4 mt-4"
                  }) : JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(HighlightSection__Jsx3.make, {
                          background: "Muted",
                          children: "No members match your search"
                        }),
                    className: "mt-4"
                  }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(PaginationBoxRefetchable.make, {
                        previousPagePath: match$5.hasPreviousPage ? (
                            startCursor !== undefined ? "?before=" + startCursor + search$1 : "#"
                          ) : undefined,
                        onClickPrevious: (function () {
                            startTransition(function () {
                                  refetch(makeRefetchVariables(Caml_option.some(undefined), Caml_option.some(startCursor), Caml_option.some(undefined), 10, chapter.nodeId, Caml_option.some(searchText)), undefined, undefined);
                                });
                            setQueryParams("replace", {
                                  after: undefined,
                                  before: startCursor,
                                  search: searchTextOpt
                                });
                          }),
                        nextPagePath: match$5.hasNextPage ? (
                            endCursor !== undefined ? "?after=" + endCursor + search$1 : "#"
                          ) : undefined,
                        onClickNext: (function () {
                            startTransition(function () {
                                  refetch(makeRefetchVariables(Caml_option.some(endCursor), Caml_option.some(undefined), 10, Caml_option.some(undefined), chapter.nodeId, Caml_option.some(searchText)), undefined, undefined);
                                });
                            setQueryParams("replace", {
                                  after: endCursor,
                                  before: undefined,
                                  search: searchTextOpt
                                });
                          })
                      }),
                  className: "mt-8 text-center"
                })
          ]
        });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(SearchField.make, {
                            value: searchText,
                            placeholder: "Search for members",
                            onChange: (function (evt) {
                                var value = evt.target.value;
                                setSearchText(function (param) {
                                      return value;
                                    });
                                search(value);
                                setQueryParams("replace", {
                                      after: undefined,
                                      before: undefined,
                                      search: value
                                    });
                              })
                          }),
                      className: "mt-8"
                    }),
                tmp
              ]
            });
}

var make = ChapterMembersListRelay;

exports.ChapterFragment = ChapterFragment;
exports.make = make;
/* react Not a pure module */
